import { SparkWidgetLazy } from './sparkWidgetLazy';

const props = [];

export const SparkWidgetDirective = reactDirective => reactDirective(SparkWidgetLazy, props);
SparkWidgetDirective.$inject = ['reactDirective'];

// eslint-disable-next-line no-undef
angular.module('WB.App').directive('sparkWidget', SparkWidgetDirective);
